module.exports = __webpack_public_path__ + "img/active-salary-add.7ad11fef.svg";